// Styles for OneUpHighlight go here.
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledOneUpHighlight = styled.div`
  .luxury-OneUpHighlight {
    padding: ${toRem(64)} 0;
    align-items: center;

    p {
      margin-bottom: 0;
    }
  }

  .luxury-OneUpHighlight-image,
  .luxury-OneUpHighlight-video {
    width: 100%;
    aspect-ratio: 9/16;
  }
  .no-thumbnail {
    .video-image-container {
      min-height: ${toRem(847)};
      @media ${baseVariables.mediaQuery.md} {
        min-height: ${toRem(1046)};
      }
      @media ${baseVariables.mediaQuery.lg} {
        min-height: ${toRem(819)};
      }
    }
  }
  .luxury-OneUpHighlight-video {
    .video-image-container {
      img {
        width: 100%;
      }

      svg {
        width: ${toRem(48)};
        height: ${toRem(48)};
      }
    }
  }

  .video-modal-container {
    aspect-ratio: 9/16 !important;
  }

  [dir='rtl'] & {
    .text-container {
      margin-left: 0;
    }
    .asset-container {
      margin-left: 0;
    }
  }
`;
